import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { BankService } from '../../../core/services/bank/bank/bank.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'

@Component({
  selector: 'bank-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatInputModule,
    MatSlideToggle,
  ],
  templateUrl: './bank-create.component.html',
  styleUrl: './bank-create.component.scss',
  providers: [BankService],
  standalone: true,
})
export class BankCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private bankService: BankService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.bankService.createBank(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.createForm()
      },
    })
  }

  createModel() {
    return {
      codigoBanco: this.form.controls['code_bank'].value,
      nome: this.form.controls['name'].value,
      statusBanco: this.form.get('active')?.value == true ? 'S' : 'N',
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      code_bank: ['', [Validators.required]],
      name: ['', [Validators.required]],
      active: [true],
    })
  }
}
